module.exports={
  base_url:`https://sgu-open-house-api.intellivent.id`,
};
